import {t} from "@lingui/core/macro";

/**
 * A warning message for a user indicating that they've almost reached their
 * token limit for the day.
 */
export const formatUsageQuotaLowWarning = (
    usageQuotaRemaining: number,
): string => {
    const remainingPercent = Math.round(usageQuotaRemaining * 100);
    return t`I'm almost out of AI power. Only ${remainingPercent}% left for today. Be mindful using me.`;
};
